import React, { ReactNode } from 'react';
import {
  Icon, IconType, StopMarker, StopMarkerStatus,
} from '@routific/hive';
import { IColor } from '../../types/IColor';
import { VisitStatus } from '../../types/TVisit';
import { RouteTimelineEventSummaryDtoModelType } from '../../store/mst/models';

interface Props {
  eventType?: string;
  status?: string;
  color?: IColor;
  altColor?: IColor;
  sequence?: number | null;
  isHovered?: boolean;
  loading?: boolean;
  eventSummary?: RouteTimelineEventSummaryDtoModelType | null;
}

const getMarkerStatus = (
  eventType: string | undefined,
  status: string | undefined,
  eventSummary?: RouteTimelineEventSummaryDtoModelType | null,
): StopMarkerStatus => {
  if (eventType === 'leaving_start_location' || eventType === 'reaching_end_location') {
    return status ? 'departed' : 'scheduled';
  }
  if (eventSummary?.hasDeliveryIssue) return 'exception';
  if (status === VisitStatus.DEPARTED) return 'departed';
  if (status === VisitStatus.ARRIVED) return 'arrived';
  return 'scheduled';
};

const getIcon = (eventType: string | undefined): ReactNode | null => {
  switch (eventType) {
    case 'leaving_start_location':
      return <Icon icon={IconType.StartLocation} size="small" style={{ color: 'inherit' }} />;
    case 'reaching_end_location':
      return <Icon icon={IconType.EndLocation} size="small" style={{ color: 'inherit' }} />;
    case 'idling':
      return <Icon size="small" icon={IconType.IdleTime} style={{ color: 'inherit' }} />;
    case 'paused':
      return <Icon size="small" icon={IconType.Break} style={{ color: 'inherit' }} />;
    default:
      return null;
  }
};

const TimelineDot: React.FC<Props> = ({
  loading = false, eventType, status, altColor, color, sequence, eventSummary,
}) => {
  const markerStatus = getMarkerStatus(eventType, status, eventSummary);
  // When loading and an altColor is available (pending route change), use it for the pulse
  const effectiveColor = (loading && altColor) ? altColor : color;
  const icon = getIcon(eventType);
  const isDeliveryStop = eventType === 'delivering_stop';

  return (
    <StopMarker
      color={effectiveColor}
      sequence={isDeliveryStop ? sequence : null}
      icon={icon ?? undefined}
      status={markerStatus}
      loading={loading}
    />
  );
};

export default TimelineDot;
